<template>
  <div>
    <el-dialog
        :before-close="handleClose"
        :visible.sync="isOpen"
        :show-close="true"
        title="Tạo mã QR code"
        width="40%"
    >
      <div>
        <el-row type="flex">
          <el-col :span="8">
            <el-date-picker
                style="width: 80%"
                size="small"
                v-model="dataInput.date"
                type="date"
                value-format="yyyy-MM-dd"
                format="dd-MM-yyyy"
                placeholder="Chọn ngày"
                :clearable="false"
            ></el-date-picker>
          </el-col>

          <el-col :span="8">
            <el-button
                size="small"
                :loading="isLoading.createQr"
                @click="createQrCodeForSupperPlusManual()"
                type="primary"
            >
              Tạo QR code
            </el-button>
          </el-col>

          <el-col :span="8">
            <div style="margin-bottom: 6px">Cố định</div>
            <el-radio-group
                v-model="fixed"
            >
              <el-radio :label="true">Có</el-radio>
              <el-radio :label="false">Không</el-radio>
            </el-radio-group>
          </el-col>

        </el-row>
      </div>

      <div slot="footer">
        <div>
          <el-button type="danger" @click="handleClose">
            <i class="el-icon-circle-close"/>
            Đóng
          </el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import OtherService from "@/services/CommonService/OtherService";

export default {
  props: {
    isOpen: {
      type: Boolean,
      default: () => false
    },
  },
  data() {
    return {
      isLoading: {
        createQr: false,
      },

      dataInput: {
        date: "",
      },
      fixed: false
    }
  },
  watch: {},
  methods: {
    handleClose() {
      this.$emit("closeDialog", "create_qr_code");
      this.resetData();
    },

    resetData() {
      this.dataInput.date = "";
      this.fixed = false;
    },

    createQrCodeForSupperPlusManual() {
      if (this.dataInput.date === "") {
        this.$message({
          message: "Chọn ngày tạo mã QR Code",
          type: "error",
        });
        throw null;
      }
      this.$confirm(
          "Bạn có chắc chắn muốn tạo mã QR Code không?",
          "Thông báo!",
          {
            distinguishCancelAndClose: true,
            closeOnClickModal: false,
            confirmButtonText: "Có",
            cancelButtonText: "Không",
          }
      ).then(() => {
        this.isLoading.createQr = true;

        OtherService.createQrCodeForSupperPlus(this.dataInput, this.fixed)
            .then((resp) => {
              this.$message({
                message: resp.data.message,
                type: "success",
              });
            })
            .catch((err) => {
              this.$message({
                message: err.response.data.message,
                type: "error",
              });
            })
            .finally(() => {
              this.isLoading.createQr = false;
            });
      });
    },
  }
}
</script>

<style scoped lang="scss">
.element_options {
  margin-bottom: 10px;
}

.element_input {
  width: 90%;
}
</style>